import { render, staticRenderFns } from "./AutomationCaptionPrep.vue?vue&type=template&id=62c81af0&scoped=true"
import script from "./AutomationCaptionPrep.vue?vue&type=script&lang=js"
export * from "./AutomationCaptionPrep.vue?vue&type=script&lang=js"
import style0 from "./AutomationCaptionPrep.vue?vue&type=style&index=0&id=62c81af0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c81af0",
  null
  
)

export default component.exports